import React from 'react';
import { Spinner } from './Spinner';
import { LoaderContainerStyled } from "./styled/LoaderStyled";

interface ILoaderProps {
    bg?: React.CSSProperties["background"],
    show?: boolean,
    size?: "sm" | "md",
    children?: React.ReactNode,
}

export const Loader = ({bg, show, size, children }: ILoaderProps) =>
    show ? (
        <LoaderContainerStyled bg={bg}>
            {children ? children : <Spinner size={size}/>}
        </LoaderContainerStyled>
    ) : null;
